<script setup lang="ts">
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import SkeletonBase from '@/components/skeleton/SkeletonBase.vue'
import PhIcon from '@/components/PhIcon.vue'

const appStore = useAppStore()
const notification = computed(() => appStore.notification)

const bgClass = [
  'bg-linear-to-br from-stone-500 to-stone-600',
  'bg-linear-to-br from-green-500 to-emerald-600',
  'bg-linear-to-br from-rose-500 to-red-600',
  'bg-linear-to-br from-yellow-500 to-amber-600',
  'bg-linear-to-br from-cyan-500 to-blue-600',
]

const iconNotification = ['info', 'check-circle', 'warning-octagon', 'warning', 'info']
</script>

<template>
  <div
    v-if="!!notification"
    :class="bgClass[notification.status]"
    class="flex gap-2 text-white px-4 py-1"
  >
    <div class="flex gap-1 bg-black/10 rounded-md px-2 py-1">
      <ph-icon :name="iconNotification[notification.status]" :size="20"></ph-icon>
      <b class="block self-center">Info</b>
    </div>
    <span class="font-serif font-semibold self-center">{{ notification.message }}</span>
  </div>
  <div v-else class="h-4">
    <skeleton-base width="full" height="8" rounded="lg" color="stone"></skeleton-base>
  </div>
</template>

<style scoped></style>
